<template>
    <div>
        <!-- <invite-poster :platform="platform" :shareUrl="shareUrl" :inviteType="inviteType" :name="userName" @handleShareCard="handleShareCard" v-if="showPoster"></invite-poster> -->

        <section :class="['share-area', 'absolute']">
            <div class="sub-title">
                {{'分享到'}}
            </div>

            <div class="icons">
                <figure @click="(e)=>{e.preventDefault(); handleShareText('WX')}">
                    <img :src="`${baseUrl}/icon-wechat-circle-2.png`" alt="分享到微信" />
                    <figcaption>微信</figcaption>
                </figure>
                <figure @click="(e)=>{e.preventDefault(); handleShareText('WXCircle')}">
                    <img :src="`${baseUrl}/icon-moments-circle-2.png`" alt="分享到微信朋友圈" />
                    <figcaption>朋友圈</figcaption>
                </figure>
                <figure @click="(e)=>{e.preventDefault(); handleShareText('QQ')}">
                    <img :src="`${baseUrl}/icon-qq-circle-2.png`" alt="分享到QQ" />
                    <figcaption>QQ</figcaption>
                </figure>
                <figure @click="(e)=>{e.preventDefault(); handleShareText('QQZone')}">
                    <img :src="`${baseUrl}/icon-qzone-circle-2.png`" alt="分享到QQ空间" />
                    <figcaption>QQ空间</figcaption>
                </figure>
            </div>

        </section>
    </div>
</template>

<script>
// 页中分享和页底分享
import shareInApp from '@/components/dumb/shareInApp.vue';
// import invitePoster from './invite-poster';
import { share } from '@/utils/hybird.js';
import { isIOS } from '@/utils/env.js';
import qs from '@/utils/queryString';
import utils from "@/assets/js/utils";

const APP_VERSION = 3758; //支持朋友圈分享卡片的版本

export default {
    components: { shareInApp },
    props: ['shareUrl', 'shareDesc', 'shareTitle','actionCode'],
    data() {
        return {
            showPoster: false,
            platform: 'WXCircle',
            baseUrl: 'https://appd.knowbox.cn/ss/activity/ss-teacher-h5/t-task-system',
        };
    },
    computed: {
        // shareUrl() {
        //     const token = qs.getValue('token');
        //     // 分享到QQ会默认加个参数 &appinstall=0；所以 #/share-page 放在URL最后会出错
        //     return `${location.origin + location.pathname}#/share-page?token=${token}&username=${encodeURIComponent(this.userName)}&code=${this.inviteCode}`;
        // }
    },
    methods: {
        shareCard(platform) {
            const version = Number(qs.getValue('version'));
            if (version < APP_VERSION) {
                return this.handleShareText(platform);
            }

            this.platform = platform;
            this.showPoster = true;
        },

        handleShareCard(dataUrl) {
            this.showPoster = false;

            let text = '';
            let title = '';
            let titleUrl = '';
            let url = '';
            let description = '';
            let site = '小盒科技';
            let siteUrl = 'http://ssapp.knowbox.cn';
            let callback = () => { };

            let type = 2;
            let imageUrl = '';
            let imgPath = '';
            if (isIOS()) {
                imageUrl = dataUrl;
                type = 1; //iOS下代表图片；
            } else {
                imgPath = dataUrl; //android下表示传递 Date URL
            }

            // chrome限制url不能大于2m；否则 about:black
            // const buf = new TextEncoder().encode(dataUrl)
            // console.log(new Blob([buf]).size/1024/1024)

            share(
                this.platform,
                text,
                title,
                imageUrl,
                titleUrl,
                url,
                description,
                site,
                siteUrl,
                callback,
                type,
                imgPath,
            );
            this.$emit('closeWrap');
        },

        handleShareText(platform) {
            let type = "";
            switch(platform){
                case "WX":
                    type = 0;
                    break
                case "WXCircle":
                    type = 1;
                    break
                case "QQ":
                    type = 2;
                    break
                case "QQZone":
                    type = 3;
                    break
            }
            utils.sendLog({
                token: qs.getValue('token'),
                version: qs.getValue('version'),
                source: qs.getValue('source'),
                extensionJson: {
                    type: type,
                }
            }, this.actionCode);

            const conf = {
                title: this.shareTitle,
                text: this.shareDesc,
                imageUrl: 'https://susuanqiniu.knowbox.cn/108_108.png',
                url: this.shareUrl,
                titleUrl: this.shareUrl,
                description: '小盒课堂',
                site: 'https://knowbox.cn',
                siteUrl: 'https://knowbox.cn',
                type: 2, //默认传2，但端上默认不使用
            };
            share(
                platform,
                conf.text,
                conf.title,
                conf.imageUrl,
                conf.titleUrl,
                conf.url,
                conf.description,
                conf.site,
                conf.siteUrl,
                conf.callback,
                conf.type
            );
            this.$emit('closeWrap');
        },
    }
};
</script>

<style lang="scss" scoped>
.share-area.static {
    margin-top: 0.55rem;

    .sub-title {
        font-size: 0.28rem;
        color: rgb(191,191,191);
    }
}

.icons {
    display: flex;
    justify-content: center;
    margin-top: 0.25rem;
    figure {
        flex: none;
        width: 1.67rem;
        img {
            width: 0.95rem;
            height: 0.95rem;
        }
        figcaption {
            font-size: 0.26rem;
            color: rgb(143,150,158);
            line-height: 0.38rem;
        }
    }
}

@keyframes slideInUp {
    from {
        transform: translate3d(0, 100%, 0);
        visibility: visible;
    }
    to {
        transform: translate3d(0, 0, 0);
    }
}

.share-area.absolute {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3.19rem;
    text-align: center;
    background-color: #fff;
    border-radius: .2rem .2rem 0 0;
    animation: slideInUp 0.3s;
    .sub-title {
        font-size: 0.26rem;
        color: #8f969e;
        margin: .3rem auto;
    }
    .icons figure {
        flex: 1;
        img {
            width: 1.38rem;
            height: 1.38rem;
        }
        figcaption {
            margin-top: 0.1rem;
        }
    }
}
</style>
